import { Star } from 'lucide-react'
import { match } from 'ts-pattern'
import { cn } from '~/utils'
import { Plan } from '../types'

type PlanIconProps = {
  plan: Plan
}

export const PlanIcon = ({ plan }: PlanIconProps) => {
  const background = match(plan)
    .with('community', () => 'bg-gray-400')
    .with('plus', () => 'bg-blue-600')
    .with('team', () => 'bg-green-600')
    .with('enterprise', () => 'bg-black')
    .exhaustive()

  return <Star className={cn('rounded-md p-1 text-white', background)} />
}
